import { type PartnerEntity } from '../../aspida/@types'

/**
 * 荷物重量の表示単位
 */
export type WeightDisplayUnit = PartnerEntity['weightDisplayUnit']

export const WEIGHT_DISPLAY_UNIT = {
  /** トン */
  TON: 'TON',
  /** キログラム */
  KILOGRAM: 'KILOGRAM'
} as const satisfies Record<WeightDisplayUnit, WeightDisplayUnit>

/**
 * 単位ごとの小数桁数の上限（Issue #4905）。
 * 100g まで表示できるようにするため、t は 0.0001（小数第4位）、kg は 0.1（小数第1位）が
 * 「1kg単位入力の最小刻み」に相当し、それぞれ 1 桁の余裕を持たせた値。
 */
export const WEIGHT_DISPLAY_MAX_FRACTION_DIGITS = {
  [WEIGHT_DISPLAY_UNIT.TON]: 5,
  [WEIGHT_DISPLAY_UNIT.KILOGRAM]: 2
} as const satisfies Record<WeightDisplayUnit, number>
